<template>
    <div class="total-checkins">
        <Card size="small">
            <header>
                <div class="name">Check-ins</div>
            </header>
            <p class="paragraph-below">
                <b>{{ totalCheckins }}</b> check-in / <b>{{ totalCheckouts }}</b> check-out
            </p>
        </Card>
    </div>
</template>

<script>
import Card from '@/components/Card'

export default {
    name: 'TotalCheckins',
    components: {
        Card,
    },
    props: {
        totalCheckins: {
            type: Number,
            default: undefined,
        },
        totalCheckouts: {
            type: Number,
            default: undefined,
        },
    },
}
</script>

<style scoped lang="sass">
.total-checkins
    max-width: 100vw
    width: 100%
    box-sizing: border-box

    .paragraph-below
      padding-left: $xs

    .empty-state
        display: flex
        justify-content: center
        align-items: center
        height: 100px
        text-align: center
        user-select: none

    .card
        min-height: 64px
        box-sizing: border-box
        background: #ffffff !important
    header
        display: flex
        justify-content: space-between
        margin-bottom: $s

        .d-select
            min-width: 80px

        .name
            color: $neutral-black
            font-weight: 600
            padding: $xs
            font-size: 14px
            line-height: 17px

    .chart-content
        margin: 0 auto
        width: 244px
        display: grid
        grid-row-gap: 12px
        grid-template-areas: "data data data data data" "indicator indicator indicator indicator indicator" "label label label label label"

        .bar
            height: 90px
            display: flex
            justify-content: center
            width: 100%
            align-items: flex-end

            .data
                width: 20px
                border-radius: 7px
                position: relative
                display: flex
                justify-content: center
                align-items: flex-end
                background-color: #0399DA

                &.zero
                    min-height: 4px
                    background-color: $gray-1

                &:hover
                    .d-tooltip
                        opacity: 1
                        transform: translateY(0)

        .indicator
            border-top: 1px solid $gray-1
            display: flex
            justify-content: center

            .inner-line
                width: 1px
                height: 8px
                background-color: $gray-1
        .label
            display: flex
            font-size: 12px
            justify-content: center
            color: #575962

        .chart-container
            width: 432px
</style>
